import { storage, STORAGE_KEYS } from '@/src/general/utilities/storage/MMKVStorage'

const getAccountStorageKey = (userId: number) => `${STORAGE_KEYS.NEW_PRAYER_SPACE_MODAL_SHOWN}:${userId}`

export const hasSeenNewPrayerSpaceOnboarding = (userId: number) => {
  const accountStorageKey = getAccountStorageKey(userId)
  if (storage.getItem(accountStorageKey)) return true

  const hasSeenLegacyModal = storage.getItem(STORAGE_KEYS.NEW_PRAYER_SPACE_MODAL_SHOWN)
  if (!hasSeenLegacyModal) return false

  storage.setItem(accountStorageKey, 'true')
  storage.removeItem(STORAGE_KEYS.NEW_PRAYER_SPACE_MODAL_SHOWN)
  return true
}

export const markNewPrayerSpaceOnboardingAsSeen = (userId: number) =>
  storage.setItem(getAccountStorageKey(userId), 'true')

export const removeNewPrayerSpaceOnboardingAccountState = (userId: number) =>
  storage.removeItem(getAccountStorageKey(userId))
